import { useState, useEffect } from 'react';

const useDeveloperMode = () => {
  // Developer console state
  const [devUnitSearch, setDevUnitSearch] = useState('99');
  const [devSelectedUnit, setDevSelectedUnit] = useState(null);
  
  // Overlay visibility state
  const [showGridOverlay, setShowGridOverlay] = useState(false);
  const [showDebugOverlay, setShowDebugOverlay] = useState(false);
  const [showTargetedDebug, setShowTargetedDebug] = useState(false);
  const [showElementSelector, setShowElementSelector] = useState(false);
  const [showEditableOverlay, setShowEditableOverlay] = useState(false);
  
  // Console and design state
  const [gridSize, setGridSize] = useState(20);
  const [savedDesign, setSavedDesign] = useState({});
  const [isConsoleMinimized, setIsConsoleMinimized] = useState(false);
  
  // Target elements for debugging
  const [targetElements, setTargetElements] = useState([]);

  // Load saved design on mount
  useEffect(() => {
    const savedDesign = localStorage.getItem('battleUI_design');
    if (savedDesign) {
      try {
        const designChanges = JSON.parse(savedDesign);
        setSavedDesign(designChanges);
      } catch (error) {
        console.error('Error loading saved design:', error);
      }
    }
  }, []);

  return {
    // Developer console state
    devUnitSearch,
    setDevUnitSearch,
    devSelectedUnit,
    setDevSelectedUnit,
    
    // Overlay visibility
    showGridOverlay,
    setShowGridOverlay,
    showDebugOverlay,
    setShowDebugOverlay,
    showTargetedDebug,
    setShowTargetedDebug,
    showElementSelector,
    setShowElementSelector,
    showEditableOverlay,
    setShowEditableOverlay,
    
    // Console and design
    gridSize,
    setGridSize,
    savedDesign,
    setSavedDesign,
    isConsoleMinimized,
    setIsConsoleMinimized,
    
    // Target elements
    targetElements,
    setTargetElements
  };
};

export default useDeveloperMode;
